var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "qm-editor" },
    [
      _c("Toolbar", {
        staticClass: "qm-editor-toolbar",
        attrs: {
          mode: _vm.simpleMode ? "simple" : "",
          editor: _vm.editor,
          defaultConfig: _vm.innerToolbarConfig,
        },
      }),
      _c("Editor", {
        staticClass: "qm-editor-editor",
        style: { height: _vm.height },
        attrs: {
          mode: _vm.simpleMode ? "simple" : "",
          defaultConfig: _vm.innerEditorConfig,
        },
        on: { onCreated: _vm.onCreated },
        model: {
          value: _vm.html,
          callback: function ($$v) {
            _vm.html = $$v
          },
          expression: "html",
        },
      }),
      _vm.supportImage && _vm.pictureLibrary
        ? _c(
            "qm-picture-library",
            _vm._b(
              {
                attrs: {
                  visible: _vm.visible,
                  "append-to-body": true,
                  activeName: _vm.activeName,
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.visible = $event
                  },
                  change: _vm.onChange,
                },
              },
              "qm-picture-library",
              Object.assign({}, { multiple: true }, _vm.pictureLibraryProps),
              false
            )
          )
        : _vm._e(),
      _vm.supportVideo
        ? _c("UploadVideoPop", {
            ref: "uploadVideoPop",
            attrs: { useScene: "editor", uploadType: "aliyun" },
            on: { videoUploadedSuccess: _vm.onVideoChange },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }